<template>
<div id="policies_href" class="policies-bg policies-bg-sm policies-bg-lg policies-bg-2xl bg-center flex items-center ">
  <div class="max-w-7xl mx-auto w-full px-10">
    <div class="flex justify-between sm:justify-start items-center">
    <h2 class="text-size text-3xl lg:text-4xl font-black text-left">使用條款及隱私權政策</h2>
    <a href="/policies" class="hidden sm:block"><div class="detail-btn text-white flex items-center justify-center ml-3 sm:ml-10 flex-none">詳細資訊&ensp;></div></a>
    </div>
    <!-- 客戶自行輸入欄位 -->
    <p class="text-lg lg:text-xl font-black text-left mt-3 lg:mt-5 over-line text-color-green">{{ content }}</p>
    <div class="hidden sm:block">
      <p class="text-lg font-black text-left mt-10">使用條款  v.20230801 【適用範圍】</p>
      <p class="text-lg text-left mt-2 over-lineX3">本網站由農業部生物多樣性研究所負責維運。本站其上素材與資料，除另行標示者外，歸該單位所有。<br>
      本頁面的著作權政策，適用於您TAIE網站活動時，所涉及之授權與被授權關係。<br>
      使用者繼續使用TAIE網站服務之作為，視為當事人明示同意下述之使用條款…</p>
    </div>
    <a href="/policies" class="sm:hidden"><div class="detail-btn text-white flex items-center justify-center flex-none mt-5">詳細資訊&ensp;></div></a>
  </div>
</div>
</template>

<script>
// import UserService from "@/services/user.service";
import { getTermsOfUse } from '@/api/terms-of-use'

export default {
  name: "Policies",

  data() {
    return {
      content: "",
    };
  },

  mounted() {
    getTermsOfUse(300).then(
      (response) => {
        this.content = response.data.content_text;
      },
      (error) => {
        this.content =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
      }
    );
  },
};
</script>

<style scoped>
@media (min-width: 1536px) {
  .policies-bg-2xl {
    width: 100%;
    height: 500px;
    background-image: url("../../assets/policies-bg-1920.jpg");
  }
}

@media (min-width: 1024px) and (max-width: 1535.98px) {
  .policies-bg-lg {
    width: 100%;
    height: 500px;
    background-image: url("../../assets/policies-bg-1536.jpg");
  }
}

@media (min-width: 640px) and (max-width: 1023.98px) {
  .policies-bg-sm {
    width: 100%;
    height: 400px;
    background-image: url("../../assets/policies-bg-1024.jpg");
  }
}

@media (max-width: 639.98px) {
  .policies-bg {
    width: 100%;
    height: 250px;
    background-image: url("../../assets/policies-bg-640.jpg");
  }
}

@media (max-width: 419.98px) {
  .text-size {
    font-size: 1.5rem;
    line-height: 2rem;
  }
}

.detail-btn{
  width: 125px;
  height: 50px;
  background-color: #628587;
  mask-image: url(../../assets/btn-bg.svg);
}

.detail-btn:hover {
  background-color: #496365;
}

.over-line {
  overflow: hidden;
  -webkit-line-clamp: 2;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}

.over-lineX3 {
  overflow: hidden;
  -webkit-line-clamp: 3;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}

.text-color-green {
  color: #3D6158;
}
</style>
